import firebase from 'firebase/compat/app';
import { initializeApp } from "firebase/app";
import { getAnalytics, setAnalyticsCollectionEnabled, Analytics } from "firebase/analytics";
import { getStorage } from 'firebase/storage';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_authDomain,
  projectId: process.env.REACT_APP_FIREBASE_projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_storageBucket,
  messagingSenderId: process.env.REACT_APP_FIREBASE_messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_appId,
  measurementId: process.env.REACT_APP_FIREBASE_measurementId
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
// Disable analytics collection by default until consent is given
setAnalyticsCollectionEnabled(analytics, false);

const storage = getStorage(app) as firebase.storage.Storage;
const firestore = getFirestore(app);

export { firestore, storage, analytics, app as default };
export const FIREBASE_APP = app; // No need to initialize twice
export const FIREBASE_AUTH = getAuth(FIREBASE_APP);
export const FIREBASE_FIRESTORE = firestore; // Use the already initialized firestore